// 拦截编程式导航，自动添加 curuserid 和 token 参数

import Router from 'vue-router'

const interceptPushReplace = (instance, location) => {
  if (typeof location === 'string') {
    location = {
      path: location,
      query: {}
    }
  } else if (typeof location.query !== 'object') {
    location.query = {}
  }

  location.query.curuserid =
    location.query.curuserid || instance.currentRoute.query.curuserid
  location.query.token =
    location.query.token || instance.currentRoute.query.token

  if (instance.currentRoute.query.show_mode) {
    location.query.show_mode =
      location.query.show_mode || instance.currentRoute.query.show_mode
  }

  return location
}

// 拦截 push
const oldPush = Router.prototype.push

Router.prototype.push = function(location, onComplete, onAbort) {
  location = interceptPushReplace(this, location)

  return oldPush.call(this, location, onComplete, onAbort)
}

// 拦截 replace
const oldReplace = Router.prototype.replace

Router.prototype.replace = function(location, onComplete, onAbort) {
  location = interceptPushReplace(this, location)

  return oldReplace.call(this, location, onComplete, onAbort)
}
